import { useEffect } from 'react';

import { RowId } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/types';

export function RowExpanderSync(props: {
  rowId: RowId;
  expandAll: boolean;
  getDesired: (rowId: RowId, expandAll: boolean) => boolean;
  subArrowsAreVisible: boolean;
  showSubArrows: (v: boolean) => void;
}) {
  const { rowId, expandAll, getDesired, subArrowsAreVisible, showSubArrows } = props;
  const desired = getDesired(rowId, expandAll);

  useEffect(() => {
    if (desired !== subArrowsAreVisible) {
      showSubArrows(desired);
    }
  }, [desired, subArrowsAreVisible, showSubArrows]);

  return null;
}
